import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../mock';
import { Car, Plane, Briefcase, Clock } from 'lucide-react';

export const Home = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const serviceIcons = [Car, Plane, Briefcase, Clock];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 md:py-32 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-transparent z-10" />
          <img
            src={images.heroImage}
            alt="GoBru Taxi"
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1F3C88] mb-6 leading-tight">
              {t.home.heroTitle}
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed">
              {t.home.heroDescription}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => navigate('/contact')}
                className="bg-[#FBC02D] text-[#1F3C88] hover:bg-[#f9b200] font-semibold px-8 py-6 text-lg"
              >
                {t.home.bookRide}
              </Button>
              <Button
                onClick={() => navigate('/contact')}
                variant="outline"
                className="border-[#1F3C88] text-[#1F3C88] hover:bg-[#1F3C88] hover:text-white font-semibold px-8 py-6 text-lg"
              >
                {t.home.contactUs}
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1F3C88] text-center mb-12">
            {t.home.servicesTitle}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {t.home.services.map((service, index) => {
              const Icon = serviceIcons[index];
              return (
                <Card
                  key={index}
                  className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <CardContent className="p-6">
                    <div className="w-12 h-12 bg-[#FBC02D] rounded-lg flex items-center justify-center mb-4">
                      <Icon className="h-6 w-6 text-[#1F3C88]" />
                    </div>
                    <h3 className="text-xl font-semibold text-[#1F3C88] mb-2">
                      {service.title}
                    </h3>
                    <p className="text-gray-600">{service.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <img
                src={images.taxiCar}
                alt="Professional Taxi"
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
            <div>
              <img
                src={images.taxiCar2}
                alt="Professional Taxi"
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
            <div>
              <img
                src={images.professionalCab}
                alt="Clean Taxi Service"
                className="rounded-lg shadow-xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};